export const newFileExperienceClassName = 'new-file-experience-wrapper';
